const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }]
}

export default conditions
